import React from "react";
import Grid2 from "@mui/material/Grid2";
import {
  profileFormColumnSpacing,
  profileFormGridSx,
  profileFormRowSpacing,
} from "../profileFieldStyles";

export function ProfileFormGrid({ children }) {
  return (
    <Grid2
      container
      columnSpacing={profileFormColumnSpacing}
      rowSpacing={profileFormRowSpacing}
      sx={profileFormGridSx}
    >
      {children}
    </Grid2>
  );
}
